module.exports = __webpack_public_path__ + "static/iphone@2x-f10d5f3a399396c04a84cc643eb49012.jpg";